import { Box, Flex } from '@chakra-ui/layout'
import { Image } from '@chakra-ui/image'

import { VscHome } from 'react-icons/vsc'
import {
  FiMonitor,
  FiLogOut,
  FiSettings,
  FiDollarSign,
} from 'react-icons/fi'
import { TbDiscount, TbCalendar, TbChartArcs } from 'react-icons/tb'
import { FiUsers } from 'react-icons/fi'

import { useAuth } from '../../../hooks/useAuth'

import { NavLink } from '../NavLink'

import { CustomerTypeEnum } from '../../../schemas/enum.schemas'

import { TicketDiagonalOutlineIcon } from '../../../assets/icons/TicketDiagonalOutlineIcon'
import { StarOutlineIcon } from '../../../assets/icons/StarOutlineIcon'
import { AccreditedIcon } from '../../../assets/icons/AccreditedIcon'

export function SidebarContent() {
  const { signOut, user } = useAuth()

  const role = user?.customer?.role || 'ROLE'
  const restrictions = ['MANAGER', 'ADMINISTRATOR', 'SUPER_ADMIN'].includes(role)

  return (
    <Box
      as="nav"
      position="fixed"
      background="parkoff.orange.300"
      top="0"
      left="0"
      overflowX="hidden"
      overflowY="auto"
      zIndex="sticky"
      height="full"
      width="12.3125rem"
    >
      <Flex paddingX="1.375rem" paddingY="1.75rem" alignItems="center">
        <Image src="https://parkoff-prod.s3.us-east-2.amazonaws.com/assets/svg/logo-black.svg" />
      </Flex>
      <Flex as="nav" direction="column" fontSize="sm" aria-label="Menu">
        <NavLink icon={VscHome} to="/home">
          Home
        </NavLink>
        {user?.customer.type === CustomerTypeEnum.enum.ADMIN && (
          <NavLink icon={FiMonitor} to="/management">
            Gestão
          </NavLink>
        )}
        {user?.customer.type === CustomerTypeEnum.enum.PARKING && (
          <NavLink icon={TicketDiagonalOutlineIcon} to="/booking">
            Reservas
          </NavLink>
        )}
        {restrictions && (
          <NavLink icon={FiDollarSign} to="/financial">
            Financeiro
          </NavLink>
        )}
        {restrictions && (
          <NavLink icon={TbDiscount} to="/coupons">
            Cupons
          </NavLink>
        )}
        {(user?.customer.type === CustomerTypeEnum.enum.ADMIN || user?.customer.role === 'ADMINISTRATOR') && (
          <NavLink icon={FiUsers} to="/users">
            Acessos
          </NavLink>
        )}
        <NavLink icon={TbCalendar} to="/monthly">
          Mensalistas
        </NavLink>
        <NavLink icon={AccreditedIcon} to="/accredited">
          Credenciados
        </NavLink>
        {restrictions && (
          <NavLink icon={StarOutlineIcon} to="/rating">
            Avaliações
          </NavLink>
        )}
        {restrictions && (
          <NavLink icon={TbChartArcs} to="/dashboard">
            Dashboard
          </NavLink>
        )}
        {restrictions && (
          <NavLink
          icon={FiSettings}
          to={
            user?.customer.type === CustomerTypeEnum.enum.ADMIN
              ? '/configuration-admin'
              : `/configuration/${user?.parking.id}`
          }
          >
            Configurações
          </NavLink>
        )}
        <NavLink icon={FiLogOut} to="/" onClick={() => signOut()}>
          Sair
        </NavLink>
      </Flex>
    </Box>
  )
}
